import { Controller } from "@hotwired/stimulus"

// Bascule entre « réponse au demandeur » et « note interne ».
export default class extends Controller {
  static targets = ["tab", "internal", "body", "label", "submit"]

  connect() {
    this.replyPlaceholder = this.bodyTarget.placeholder
    this.element.addEventListener("submit", () => {
      this.submitTarget.disabled = true
      this.labelTarget.textContent = "Envoi…"
    })
  }

  select(event) {
    const note = event.currentTarget.dataset.mode === "note"
    this.tabTargets.forEach((tab) => tab.classList.toggle("is-active", tab === event.currentTarget))
    this.internalTarget.value = note ? "1" : "0"
    this.element.classList.toggle("is-note", note)
    this.bodyTarget.placeholder = note ? "Note visible uniquement par l'équipe HEX…" : this.replyPlaceholder
    this.labelTarget.textContent = note ? "Ajouter la note" : "Envoyer"
    this.bodyTarget.focus()
  }

  submit(event) {
    event.preventDefault()
    this.element.requestSubmit()
  }
}
